import { Injectable, Injector } from '@angular/core';
import { environment } from '../../environments/environment';
import { Config } from '../models/config.model';
import { localStorageKeys } from './system.service';

/**
 * Servicio de configuración de la aplicación.
 *
 * Responsabilidades:
 * - `authApi`: solo bela-belleza-auth (login), desde `environment.authApiUrl` (Base64).
 * - `servicesAPI`: bela-belleza-api (negocio), **no** está en environment: solo tras login, Base64 en localStorage.
 * - Gestionar secreto compartido para firma JWT de payloads (HS256)
 * - Gestionar versión de la aplicación
 */
@Injectable()
export class AppConfigService {
    public config: Config = new Config();

    constructor(private readonly injector: Injector) {
        this.config.version = environment.version;
        this.config.secret = this.base64ToString(environment.secretBase64);
        this.config.sidebarFixed = true;
        this.setApisURL();
    }

    get urlLogin(): string {
        return '/auth/login';
    }

    /**
     * Actualiza las URLs según la sesión.
     * - authApi: bela-belleza-auth desde environment (necesario antes del login).
     * - servicesAPI: bela-belleza-api desde localStorage (valor Base64 que devolvió el login en `servicesAPI`).
     */
    setApisURL(): void {
        this.config.authApi = this.base64ToString(environment.authApiUrl);

        const hasSession = !!localStorage.getItem(localStorageKeys.sessionToken);
        if (!hasSession) {
            this.config.servicesAPI = '';
            return;
        }

        const rawServicesApi = localStorage.getItem(localStorageKeys.servicesAPI);
        this.config.servicesAPI = rawServicesApi ? this.base64ToString(rawServicesApi) : '';
    }

    private base64ToString(value: string): string {
        try {
            return atob(value);
        } catch {
            return value;
        }
    }
}
